import { get, post, put, Delete } from "../axios";

// 考试记录-列表
export const questionExamList = (params) => get("/web/question/exam/list", params);

//答题情况
export const questionResultsList = (params) => get("/web/question/results", params);